namespace RioErp.Web.Enums {
    export enum InvoiceStatus {
        Confirmed = 1,
        Cancelled = 2
    }
    Serenity.Decorators.registerEnumType(InvoiceStatus, 'RioErp.Web.Enums.InvoiceStatus');
}
